import React, { useState } from 'react';
import { Paper } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Link, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { getStaffById } from '../../../api/staff';
import EmployeeTab1 from '../EmployeeTab1';
import EmployeeTab2 from '../EmployeeTab2';
import EmployeeTab3 from '../EmployeeTab3';
import {
  PageContainer,
  HeaderRow,
  BackLink,
  HeaderTitle,
  ListLink,
  Divider,
  TabDivider,
  NameSection,
  EmployeeName,
  TabsContainer,
  StyledTabs,
  StyledTab,
} from './EmployeeDetailStyled';
// 근무시간관리 탭 — 목업(API 미연결)이라 임시 비노출
// import WorkingTimeManagement from '../workingTimeManagement/WorkingTimeManagement';
import useUserAuth from '../../../utils/useUserAuth';

function EmployeeDetail() {
  const user = useSelector(state => state.user.user);
  const userBranch = useSelector(state => state.user.user.branch);
  const [selectedTab, setSelectedTab] = useState('one');
  const { t } = useTranslation();
  const { id } = useParams();
  const canAuthManage = useUserAuth('EMPLOYEE_AUTH_MANAGE');
  const canWorkHour = useUserAuth('EMPLOYEE_WORK_HOUR');

  const handleChange = (event, newValue) => {
    if (newValue === 'three' && !canAuthManage) return;
    if (newValue === 'four' && !canWorkHour) return;
    setSelectedTab(newValue);
  };

  const { data: employ } = useQuery({
    queryKey: ['staff', id, userBranch?.branchId],
    queryFn: () => getStaffById(id, user.token, userBranch?.branchId),
    enabled: !!id && !!user.token,
  });

  const handleTab = tab => {
    switch (tab) {
      case 'one':
        return <EmployeeTab1 employ={employ} userBranch={userBranch} />;
      case 'two':
        return <EmployeeTab2 />;
      case 'three':
        return <EmployeeTab3 employ={employ} />;
      // case 'four':
      //   return <WorkingTimeManagement />;
      default:
        return <EmployeeTab1 employ={employ} userBranch={userBranch} />;
    }
  };

  return (
    <PageContainer component={Paper} elevation={2}>
      <HeaderRow>
        <Link to="/employee" style={{ textDecoration: 'none' }}>
          <BackLink>
            <ArrowBackIcon sx={{ fontSize: 20 }} />
            <HeaderTitle>임직원 정보</HeaderTitle>
          </BackLink>
        </Link>

        <Link to="/employee" style={{ textDecoration: 'none' }}>
          <ListLink>목록으로</ListLink>
        </Link>
      </HeaderRow>

      <div>

        <TabsContainer>
          <StyledTabs
            value={selectedTab}
            onChange={handleChange}
            textColor="secondary"
            indicatorColor="secondary"
            aria-label="employee detail tabs">
            <StyledTab value="one" label={t('Employee Information')} />
            <StyledTab value="two" label={t('Clients')} />
            {/* 권한관리 탭 — 센터관리 > 권한 관리로 이동 */}
            {/* {canAuthManage ? (
              <StyledTab value="three" label={t('Employee Auth')} />
            ) : (
              <Tooltip title="권한이 없습니다" arrow>
                <StyledTab value="three" label={t('Employee Auth')} sx={{ color: '#ccc !important', opacity: '1 !important' }} />
              </Tooltip>
            )} */}
            {/* 근무시간관리 탭 — 목업(API 미연결)이라 임시 비노출 */}
            {/* {canWorkHour ? (
              <StyledTab value="four" label={t('Working time management')} />
            ) : (
              <Tooltip title="권한이 없습니다" arrow>
                <StyledTab value="four" label={t('Working time management')} sx={{ color: '#ccc !important', opacity: '1 !important' }} />
              </Tooltip>
            )} */}
          </StyledTabs>
        </TabsContainer>

        <TabDivider />
      </div>

      {handleTab(selectedTab)}
    </PageContainer>
  );
}

export default EmployeeDetail;
